const PRESETS = [["1d", 0], ["7d", 7], ["30d", 30], ["90d", 90], ["All", null]];
const iso = (d) => new Date(d.getTime() - d.getTimezoneOffset() * 6e4).toISOString().slice(0, 10);

export const DateRange = ({ from, to, onChange }) => {
  const preset = (days) => (days == null ? onChange("", "") : onChange(iso(new Date(Date.now() - days * 864e5)), iso(new Date())));
  return (
    <div className="flex items-center gap-1" data-testid="date-range">
      {PRESETS.map(([l, d]) => (
        <button key={l} data-testid={`range-${l}`} onClick={() => preset(d)}
          className={`btn-ghost text-xs px-2 py-2 ${(d == null ? !from && !to : from === iso(new Date(Date.now() - d * 864e5)) && to === iso(new Date())) ? "!text-white !border-[#007AFF]" : ""}`}>{l}</button>
      ))}
      <input data-testid="range-from" type="date" value={from} onChange={(e) => onChange(e.target.value, to)} className="field py-1.5 text-xs [color-scheme:dark]" />
      <span className="text-neutral-600 text-xs">→</span>
      <input data-testid="range-to" type="date" value={to} onChange={(e) => onChange(from, e.target.value)} className="field py-1.5 text-xs [color-scheme:dark]" />
    </div>
  );
};
